import type { ReactElement } from 'react';

import useCurrentUser from 'hooks/useCurrentUser';
import { useOrderHistory } from 'contexts/OrderHistory';

import SkuGallery from 'components/shared/SkuGallery';
import Header from './Header';
import Details from './Details';

function OrderHistoryMenu(): ReactElement {
  const { orderHistoryMenu } = useOrderHistory();
  const { upcoming_menu_items: historyMenuItems } = orderHistoryMenu;
  const { currentUser } = useCurrentUser();
  const { hasFavoritesEnabled } = currentUser;

  return (
    <div className="c-card c-order">
      <div className="c-card__content">

        <Header item={orderHistoryMenu} />

        <Details item={orderHistoryMenu} />

        {historyMenuItems && (
          <SkuGallery
            items={historyMenuItems}
            expanded={false}
            showFavoritesWidget={hasFavoritesEnabled}
          />
        )}
      </div>

    </div>
  );
}

export default OrderHistoryMenu;
